<script>

import instanceCommons from '@/mixins/instanceCommons';

export default {
  mixins: [instanceCommons],
  computed: {
    providerTabSelected() {
      return this.providerTabs.filter(
        (x) => x.param === this.$store.getProviderActionSelected
      )[0];
    },
    providerTabs() {
      return [
        {
          id: 1,
          title: "Administración de Proveedores",
          param: "provider",
          show: true,
          canBeHide: true,
        },
        {
          id: 2,
          title: "Administración de Comprobantes",
          param: "bills",
          show: !this.isEnergyPOSInstance, 
          canBeHide: true,
        },
        {
          id: 3,
          title: "Administración de Órdenes de Compra",
          param: "purchaseOrders",
          show: this.isEnergyPOSInstance,
          canBeHide: true,
        },
      ];
    },
  },
  methods: {
    changeProviderActionTo(action) {
      // this.$store.setHasToShowProviderFilters(true);
      // if (action === "provider") {
      //   this.$store.setProviderActionSelected(action);
      // } else if (action === "bills") {
      //   this.$store.setProviderActionSelected(action);
      // }
      this.$store.setHasToShowProviderFilters(true);
      this.$store.setProviderActionSelected(action); 
    },
  },
  
};
</script>
